export default __webpack_public_path__ + "static/media/serbia.e72886ad.svg";